import { Store } from 'redux'
import { Entity } from '../app/entity'
import { ApplicationState } from '../redux/ApplicationState'
import { ErrorsState } from '../redux/errors/ErrorsState'

/**
 * Loader classes like this consilidate all loading monitors for a domain
 * concept.
 *
 * They define one (or multiple) load() methods which execute an AJAX call
 * through the Api. You may implement parameter remapping and cache checks in
 * here. For the loaded date there should be a dispatched action through Redux.
 *
 * The Loader also defines a (static) method which handles its own actions and
 * applies the corresponding changes to the global store state.
 */
const Loader = function(store: Store<ApplicationState>, api) {
    this.store = store
    this.api = api

    this.loadList = parameters => {
        const globalState = this.store.getState().errors

        if (
            globalState.list &&
            globalState.list.data &&
            globalState.list.data.criteria &&
            globalState.list.data.criteria.currentPage === (parameters.page || 1) &&
            globalState.list.data.criteria.status === (parameters.status || 1) &&
            globalState.list.data.criteria.transactionIds === (parameters.transactionIds || [])
        ) {
            return
        }

        this.api.trigger('XhprofErrorBundle.Errors.errorList', parameters)
    }

    this.loadError = parameters => {
        if (!parameters.error) {
            return
        }

        const offset = parameters.offset ? parseInt(parameters.offset, 10) : 0
        const globalState = this.store.getState().errors
        if (
            globalState.errors[parameters.error] &&
            globalState.errors[parameters.error].offset === offset &&
            globalState.errors[parameters.error].isCurrent()
        ) {
            return
        }

        this.api.trigger('XhprofErrorBundle.Errors.details', parameters, parameters.error)
    }
}

const initialGlobalState: ErrorsState = {
    list: null,
    errors: {},
}

Loader.handleAction = (globalState: ErrorsState = initialGlobalState, action): ErrorsState => {
    let clonedGlobalState = {}

    switch (action.type) {
        case 'TIDEWAYS_ROUTE':
            return globalState
        case 'Errors.purge':
            return {
                list: null,
                errors: {},
            }
        case 'Errors.errorList.success':
            return {
                ...globalState,
                list: new Entity(action.data, 0),
            }
        case 'Errors.errorList.error':
            return {
                ...globalState,
                list: new Entity().setError(action.error),
            }
        case 'Errors.details.success':
            clonedGlobalState = { ...globalState.errors }
            clonedGlobalState[action.id] = new Entity(action.data, 60)

            return {
                ...globalState,
                errors: clonedGlobalState,
            }
        case 'Errors.details.error':
            clonedGlobalState = { ...globalState.errors }
            clonedGlobalState[action.id] = new Entity().setError(action.error)

            return {
                ...globalState,
                errors: clonedGlobalState,
            }
    }

    return globalState
}

export default Loader
